const storageExist = ( isLocal :boolean ) => {
    const test = 'test';
    try {
      const storage = isLocal ? localStorage : sessionStorage;
  
      storage.setItem(test, test);
      storage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };
  
  export const isLocalStorageExist = () => {
    return storageExist(true);
  };
  
  export const isSessionStorageExist = () => {
    return storageExist(false);
  };
  
  export const clearLocalStorage = () => {
    if (storageExist(true)) {
      localStorage.clear();
    }
  };
  
  export const clearSessionStorage = () => {
    if (storageExist(false)) {
      sessionStorage.clear();
    }
  };


  export const setItemToSessionStorage= (key: string, value: any) => {
    
    if( isSessionStorageExist() ){
        sessionStorage.setItem(key, value);

        return true;
    }else{
        return false;
    }
  
  }
  
  export const getItemFromSessionStorage= (key: string) => {
    
    if( isSessionStorageExist() ){
        return sessionStorage.getItem(key);
    }

    return null;
  
  }

  export const removeItemToSessionStorage = (key: string) => {
    
    if( isSessionStorageExist()  ){
        sessionStorage.removeItem(key);

        return true;
    }else{
        return false;
    }
  
  }



  